import { graphql } from '@/gql'

export const NOTIFICATION_QUERY = graphql(`
  query notification($id: UUID!) {
    notificationById(id: $id) {
      ...Notification
      notificationCustomRecipients {
        edges {
          node {
            employeeId
          }
        }
      }
      notificationGroupRecipients {
        edges {
          node {
            groupId
          }
        }
      }
      notificationCustomEmployeeFieldRecipients {
        edges {
          node {
            formFieldId
          }
        }
      }
    }
  }
`)

export const NOTIFICATIONS_QUERY = graphql(`
  query allNotifications(
    $first: Int
    $filter: NotificationFilter
    $orderBy: [NotificationsOrderBy!]
  ) {
    notifications(
      condition: { active: true }
      orderBy: $orderBy
      first: $first
      filter: $filter
    ) {
      edges {
        node {
          ...Notification
          notificationCustomRecipients {
            edges {
              node {
                employeeId
                user {
                  fullName
                  logo
                }
              }
            }
          }
          notificationGroupRecipients(
            filter: { group: { active: { equalTo: true } } }
          ) {
            edges {
              node {
                groupId
                group {
                  id
                  localizedName
                  scopeName
                }
              }
            }
          }
        }
      }
    }
  }
`)

export const NOTIFICATION_TYPES = graphql(`
  query allNotificationTypes(
    $first: Int
    $last: Int
    $after: Cursor
    $before: Cursor
    $orderBy: [NotificationTypesOrderBy!]
    $filter: NotificationTypeFilter
  ) {
    notificationTypes(
      first: $first
      last: $last
      after: $after
      before: $before
      orderBy: $orderBy
      filter: $filter
      condition: { active: true }
    ) {
      edges {
        node {
          ...NotificationType
        }
      }
      pageInfo {
        startCursor
        endCursor
        hasNextPage
      }
      totalCount
    }
  }
`)

export const NOTIFICATION_TYPE = graphql(`
  query notificationType($id: UUID!) {
    notificationTypeById(id: $id) {
      ...NotificationType
    }
  }
`)

export const NOTIFICATION_TYPES_INPUT = graphql(`
  query notificationTypesInputField(
    $filter: NotificationTypeFilter
    $after: Cursor
  ) {
    notificationTypes(
      first: 20
      condition: { active: true }
      orderBy: [NAME_ASC]
      filter: $filter
      after: $after
    ) {
      edges {
        node {
          id
          name
        }
      }
      pageInfo {
        startCursor
        endCursor
        hasNextPage
      }
    }
  }
`)

export const EMPLOYEE_NOTIFICATIONS_QUERY = graphql(`
  query allEmployeeNotifications(
    $after: Cursor
    $filter: NotificationEmployeeFilter
  ) {
    notificationEmployees(
      orderBy: [CREATED_AT_DESC]
      filter: $filter
      after: $after
      first: 10
    ) {
      edges {
        node {
          ...NotificationEmployee
        }
      }

      pageInfo {
        startCursor
        endCursor
        hasNextPage
      }

      totalCount
    }
  }
`)

export const UNREAD_NOTIFICATIONS_COUNT = graphql(`
  query unreadNotificationsCount {
    notificationEmployees(condition: { read: false }) {
      totalCount
    }
  }
`)

export const CHANNEL_TYPES = graphql(`
  query allChannelTypes {
    channelTypes {
      edges {
        node {
          id
          name
        }
      }
    }
  }
`)
